import type { Component } from 'vue';

const load = () => import('./ui/index.vue');

export const AuthModal: Component = defineAsyncComponent(() =>
  load().then((m: { default: Component }) => m.default),
);

export const prefetchAuthModal = (): void => {
  load().catch(() => null);
};
